import { createSelector } from 'reselect';

const extendedDebuggingStore = (store) => store.apps.extendedDebugging;
const performanceStore = (store) => store.apps.performance;
const routerLocation = (store) => store.router.location;

const filmStripSelector = createSelector([
  performanceStore,
  extendedDebuggingStore,
  routerLocation,
], (performanceState, extendedDebugging, location) => ({
  filmStrip: extendedDebugging.filmStrip.get('filmStrip'),
  jobId: extendedDebugging.container.getIn(['job', 'id']),
  jobInfo: performanceState.jobMetrics.get('jobInfo'),
  loaderId: performanceState.jobPerformance.get('loaderId'),
  metrics: performanceState.jobPerformance.get('performanceMetric'),
  loadingFilmStrip: extendedDebugging.filmStrip.get('loadingFilmStrip'),
  isMetricsHistoryAvailable: performanceState.metricHistory.get('isMetricsHistoryAvailable'),
  pageIndex: extendedDebugging.container.get('pageIndex'),
  filmstripMetricsHistory: performanceState.metricHistory.get('metricsHistorySummary'),
  routerSearchQuery: location.search,
}));

export {
  filmStripSelector,
  extendedDebuggingStore,
  performanceStore,
};
